import React, { useState } from 'react'
import { PaidLeaveFilterButton } from './styles'
import PAID_LEAVE from '../../../../../paidLeave/constants'
import { usePaidLeave } from '../../../../../context/paidLeaveContext'

const PaidLeaveFilter = ({ isLoading, eventHandlers, filterOptions }) => {
  const { setSelectedProduct } = usePaidLeave()
  const handleClickPaidLeaveFilter = (product) => {
    setSelectedProduct(product)
    eventHandlers.setFilterOptions({ ...filterOptions, paidLeaveType: product.id })
  }

  return (
    <React.Fragment>
      {PAID_LEAVE.PRODUCTS.map((product) => (
        <PaidLeaveFilterButton
          disabled={isLoading}
          data-testid={`paidleave-filter-button-${product.id}`}
          key={product.id}
          onClick={() => handleClickPaidLeaveFilter(product)}
          className={filterOptions.paidLeaveType === product.id ? 'active' : ''}
        >
          {product.name}
        </PaidLeaveFilterButton>
      ))}
    </React.Fragment>
  )
}

export default PaidLeaveFilter
